import { FormBase } from 'core/components';

export default class AmazonTemplatesForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'defaultPrimeTemplate',
				'amazonTemplates',
				'amazonTemplates[].systemCode',
				'amazonTemplates[].amazonCode',
				'amazonTemplates[].amazonCodeId',
			],
			labels: {
				defaultPrimeTemplate: 'AMAZONTEMPLATES.DEFAULTPRIMETEMPLATE',
				'amazonTemplates[].systemCode': '',
				'amazonTemplates[].amazonCode': '',
			},
		};
	}
}
